import { useState } from 'react';

import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useQueryAssigneeList } from 'api/queries/assigneeList.query';

interface Props {
    componentKey: string;
    widgetId?: string;
    localFilters: any;
    widgetViewMode?: WidgetViewMode;
    endpoints: Record<string, string>;
}

export const useCustomReportTextProvider = ({ localFilters, endpoints }: Props) => {
    const [description, setDescription] = useState<string>(() => {
        return localFilters ? localFilters.description : '';
    });
    const assigneeList = useQueryAssigneeList(endpoints.getAsigneList);
    return {
        ui: {
            state: {
                description,
            },
            setters: {
                setDescription,
            },
        },
        api: {
            assigneeList,
            endpoint: endpoints.getAsigneList,
        },
    };
};
